import * as React from 'react';

import {FormField} from 'shells/form/form-field';

import {GraphQLSelectAudiences} from '../../../../core/select/graphql-select-audiences';

import {FieldHelpText} from './field-help-text';
import {getAudienceError} from './get-audience-error';
import {getAudiencesForSending} from './graphql/hooks/get-audiences-for-sending';
import type {AudienceOption} from './map-audience-to-select-item';

type Props = {
    onChange: (audience: AudienceOption) => void;
    onSyncMcfxAudience: (mcfxAudience: AudienceOption) => void;
    selectedAudience: AudienceOption | null | undefined;
    isDisabled?: boolean;
    isSmsEdition?: boolean;
};

export function SendToAudienceField(props: Props) {
    const {isLoading, options} = getAudiencesForSending();

    const [selectedAudience, setSelectedAudience] = React.useState(props.selectedAudience);

    return (
        <FormField
            innerId='to'
            label='To'
            helperText={
                selectedAudience && (
                    <FieldHelpText
                        audience={selectedAudience}
                        onSyncMcfxAudience={(mcfxAudience: AudienceOption) => {
                            props.onSyncMcfxAudience(mcfxAudience);
                        }}
                        isSmsEdition={props.isSmsEdition}
                    />
                )
            }
            errorMessage={getAudienceError(props.selectedAudience)}
        >
            <GraphQLSelectAudiences
                options={options}
                isLoading={isLoading}
                selectedId={selectedAudience ? selectedAudience.value : null}
                onChange={(audience: AudienceOption) => {
                    setSelectedAudience(audience);
                    props.onChange(audience);
                }}
                // @ts-expect-error
                menuPlacement='auto'
                autoFocus={false}
                hasError={Boolean(getAudienceError(props.selectedAudience))}
                isDisabled={props.isDisabled}
            />
        </FormField>
    );
}
